import { AppPage } from "../../_common/components/app-page";
import { C, F } from "../../_common/layout";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { h } from "preact";
import { t } from "../../_i18n";
import { toastService } from "../../_services/toast-service";
import { useHistory } from "react-router";
import { useState, useEffect } from "preact/hooks";
import {
  getDocumentType,
  uploadDocument,
  getDocuments,
  downloadDocument,
} from "../../_rx/documentos/actions";
import Banner from "../../_common/components/Banner";
import DocumentsHistory from "./DocumentsHistory";
import SendDocuments from "./SendDocuments";

export let Documents = ({
  auth,
  documents,
  lang,
  getDocumentType,
  uploadDocument,
  getDocuments,
}) => {
  /** State **/
  const history = useHistory();
  const [tab, setTab] = useState("send");
  const studentId = auth.loggedUser.id;

  /** Lifecycles **/
  useEffect(() => {
    getDocumentType(lang);
    getDocuments(studentId);
  }, []);

  /** Methods **/
  const getSelectedTab = (value) => (tab === value ? "selected" : "");

  const handleChangePeriod = (tab) => setTab(tab);

  const handleSendDocuments = ({ file, formData, reset }) => {
    return uploadDocument(studentId, formData.documentType, file, {
      comment: formData.comment,
    })
      .then(() => {
        toastService.showToast({
          message: t("El documento se ha enviado correctamente"),
          type: "info",
        });
        reset();
      })
      .catch(() => {
        toastService.showToast({
          message: t("Ha ocurrido un error al enviar el documento"),
          type: "error",
        });
      });
  };

  const handleDownloadDocument = (id, name) => {
    downloadDocument(studentId, id, name);
  };

  /** Render **/
  return (
    <AppPage
      title={t("Envío de documentación")}
      back={history.goBack}
      className="max-width-980"
    >
      <F className="max-width-980 m-x2-top">
        <C>
          <Banner>
            {t('Aquí puedes enviar directamente a Secretaría académica la documentación necesaria para la gestión de tu expediente, sin necesidad de usar el correo electrónico. Los archivos enviados quedarán registrados para que los consultes posteriormente.')}
          </Banner>
        </C>
        <C>
          <div className="tabs-container">
            <div className="inline">
              <Link
                to="#"
                className={getSelectedTab("send")}
                onClick={() => handleChangePeriod("send")}
              >
                {t('Enviar documentos')}
              </Link>
            </div>
            <div className="inline">
              <Link
                to="#"
                className={getSelectedTab("history")}
                onClick={() => handleChangePeriod("history")}
              >
                {t('Historial de envíos')}
              </Link>
            </div>
          </div>
          {tab === "send" && (
            <SendDocuments
              documentType={documents.documentType}
              onSubmit={handleSendDocuments}
            />
          )}
          {tab === "history" && (
            <C className="overflow-auto">
              <DocumentsHistory
                documents={documents.documents}
                downloadDocument={handleDownloadDocument}
              />
            </C>
          )}
        </C>
      </F>
    </AppPage>
  );
};

export default connect(
  ({ documents, auth, lang }) => ({
    documents: documents,
    auth: auth,
    lang: lang,
  }),
  { getDocumentType, uploadDocument, getDocuments },
)(Documents);
